import React from 'react';
import { Link } from 'react-router-dom';
import { journalEntries } from '../data/journalData';

const ResearchJournal = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="page-hero journal-hero">
        <div className="container">
          <h1>Research Journal</h1>
          <p className="journal-tagline">
            Documenting research, insights, and emerging questions at the intersection of creativity, culture, technology, inclusion, and social change.
          </p>
        </div>
      </section>


      {/* Journal Entries Grid */}
      <section className="journal-entries">
        <div className="container">
          <div className="entries-grid">
            {journalEntries.map((entry) => (
              <div key={entry.id} className="journal-entry-card">
                <span className="research-tag">{entry.researchArea}</span>
                <h2><Link to={`/journal/${entry.id}`}>{entry.title}</Link></h2>
                <p className="entry-abstract">{entry.abstract}</p>
                <div className="entry-meta">
                  <Link to={`/journal/${entry.id}`} className="text-link">Read full entry →</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact for Collaboration */}
      <section className="journal-collaboration">
        <div className="container">
          <p className="collaboration-text">
            Interested in collaborating on any of these research streams? Reach out to us at <a href="mailto:partnerships@zirayainstitute.org">partnerships@zirayainstitute.org</a>
          </p>
        </div>
      </section>
    </>
  );
};

export default ResearchJournal;